var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNiceInterior = function SvgNiceInterior(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nice-interior_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M19.59 22.19c-.846.168-1.096.676-1.86 1.69-.076.101-.881.893-1.124 1.014-.233.116-1.634.848-2.346 1.15a.064.064 0 0 0-.025.102c.27.304 1.145 1.121 2.371 1.778 1.238.662 3.204 1.288 4.187 1.429.053.007.093-.048.075-.099-.135-.384-.264-1.216-.264-1.823 0-.862.07-1.817.677-2.875.776-1.352-.58-2.59-1.692-2.367Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.573 25.92a.254.254 0 0 0-.358-.36zm1.22.291a.254.254 0 0 0-.431-.265zm-3.598.713.08.24c1.036-.344 1.922-.868 2.298-1.244l-.18-.18-.178-.18c-.3.301-1.106.792-2.1 1.123zm2.03 1.353.216.133 1.353-2.199-.216-.133-.216-.133-1.353 2.2zm2.073-1.771a.254.254 0 1 1 .482.16zm.24 2.616-.234.096c-.215-.527-.242-1.121-.206-1.613a5 5 0 0 1 .2-1.1l.241.08.24.08a4.5 4.5 0 0 0-.175.977c-.033.454-.004.96.17 1.384zM16.883 4.96c0-.464.375-.84.84-.842l9.476-.025 9.478.03a.84.84 0 0 1 .839.84v7.42a.84.84 0 0 1-.842.842h-18.95a.84.84 0 0 1-.841-.841V4.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.956 8.292c-.811-.315-3.72 1.316-5.073 2.17v2.425c0 .187.151.338.338.338H36.84a.677.677 0 0 0 .677-.676V6.122c-.564.526-1.928 1.776-2.875 2.565-.947.79-2.312.329-2.875 0s-1.928-1.065-2.876-1.381c-.947-.316-3.438 1.315-4.566 2.17-.45-.263-1.556-.868-2.368-1.184Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.878 20.146a3.785 3.785 0 0 1 3.719 3.087c1.287-.361 2.264.417 2.747.936a1 1 0 0 1 .241.503c.02.105.04.213.04.32.002.207-.01.543-.01.58v8.807c0 .165-1.13 1.115-1.295 1.115l-23.607-.817a.3.3 0 0 1-.299-.298l-.797-9.732c0-.068.336-.037.378-.09.335-.418 1.12-.497 2.368-.338-1.015-2.199 2.03-4.073 4.306-4.073z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.271,
    height: 9.141,
    x: 14.941,
    y: 21.197,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    rx: 2.96
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M16.09 26.985h8.296c.233 0 .423.19.423.423v2.929h-9.141v-2.929c0-.233.19-.423.423-.423Zm9.165 0h8.295c.233 0 .423.19.423.423v2.929h-9.141v-2.929c0-.233.19-.423.423-.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.507,
    d: "M12.516 25.044c.321-.402 1.302-1.11 2.653-.724 2.508.58 3.136 2.493 3.136 3.377v2.654H31.33v-2.654c0-.884.627-2.798 3.135-3.377 1.351-.385 2.332.322 2.654.724v10.13H12.516z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.919 11.026c.415 0 1.015.339 1.184.846l1.783 6.354a.965.965 0 0 1-.915 1.27H8.174v14.53c0 .534-1.075 1.354-1.608 1.354l-.17-.17c-.532 0-.634.221-.634-.312V19.496l-.887-1.874c-.659 0-1.119-.39-.91-1.015l.37-2.24a.97.97 0 0 1 .916-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.507,
    d: "M5.474 18.302h1.058c.234 0 .423.19.423.423v15.978c0 .234-.19.423-.423.423H5.474a.423.423 0 0 1-.423-.423V18.725c0-.234.19-.423.423-.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.507,
    d: "M4.126 11.28h3.76c.195 0 .364.134.41.324l1.603 6.634a.423.423 0 0 1-.41.522H2.522a.423.423 0 0 1-.41-.522l1.602-6.634a.42.42 0 0 1 .411-.324Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nice-interior_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgNiceInterior;